import React from "react";
import { isFormFieldValid, getFormErrorMessage, BUSINESS_LINE_PATHS, BUSINESS_LINE_COLORS } from '../../../../../helpers/utils';
import { ReactComponent as CreditCardIcon } from "../../../../../assets/images/icons/credit-card.svg";
import CalendarIcon from "../../../../../assets/images/icons/components/CalendarIcon";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Divider } from "@mui/material";
import RadioCardOption from "_shared/RadioCardOption";
import * as utils from "../../../helpers/utils";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";


const MultipleVehicles = (props) => {
    const { formik, canAddMore, addNewVehicle, deleteVehicleItem, updateVehicleArray } = props;
    const { i18n, t } = useTranslation();
    const { businessLine } = useParams()

     // REBRANDING COLORS
    let businessColor = BUSINESS_LINE_COLORS.DEFAULT;
    if(businessLine === BUSINESS_LINE_PATHS.BSF) businessColor = BUSINESS_LINE_COLORS.BSF
    else if(businessLine === BUSINESS_LINE_PATHS.STC) businessColor = BUSINESS_LINE_COLORS.STC
    else if(businessLine === BUSINESS_LINE_PATHS.LUCID) businessColor = BUSINESS_LINE_COLORS.LUCID
    else if(businessLine === BUSINESS_LINE_PATHS.SNB) businessColor = BUSINESS_LINE_COLORS.SNB
    else if(businessLine === BUSINESS_LINE_PATHS.ALNAGHI) businessColor = BUSINESS_LINE_COLORS.ALNAGHI
    

    const usages = [
        {
            name: "Commercial",
            value: "x31"
        }
    ];
    const vehicleTypes = [
        {
            name: i18n.t("MotorEn.RegistrationType"),
            value: "registration"
        },
        {
            name: i18n.t("Motor.CustomType"),
            value: "custom"
        },
    ];

    const updateVehicleItemValue = (index, name, value) => {
        const myVehiclesArr = [...formik.values.vehicles];
        myVehiclesArr[index][name] = value;
        updateVehicleArray(myVehiclesArr);
    };

    const isRegistration = (rowData) => {
        return rowData.vehicleType === "registration";
    }

    const columns = [
        { field: 'index', header: '#', body: (rowData, { rowIndex }) => <div className="p-2">{rowIndex + 1}</div> },
        {
            field: 'vehicleType', header: i18n.t("MotorEn.RegistrationType"), body: (rowData, { rowIndex }) => {
                return <Dropdown value={rowData['vehicleType']} options={vehicleTypes}
                    onChange={(e) => updateVehicleItemValue(rowIndex, 'vehicleType', e.value)} optionLabel="name" />
            }
        },
        {
            field: 'number', header: i18n.t("MotorEn.Number"), body: (rowData, { rowIndex }) => {
                return <InputText name={'number'} value={rowData['number']}

                    className={classNames({
                        "p-invalid": isFormFieldValid(formik, "number") && !rowData.number,
                    })}
                    onChange={(e) => updateVehicleItemValue(rowIndex, 'number', e.target.value)} />
            }
        },
        {
            field: 'yom', header: i18n.t("MotorEn.Manufacture"), body: (rowData, { rowIndex }) => {
                return <Calendar
                    disabled={isRegistration(rowData)}
                    iconPos="left"
                    icon={<CalendarIcon color={businessColor} />}
                    placeholder="YYYY"
                    showIcon
                    view="year"
                    className={classNames({
                        "p-invalid": isFormFieldValid(formik, "yom") && !rowData.yom && !isRegistration(rowData),
                    })}
                    dateFormat="yy"
                    maxDate={new Date()}
                    name="yom"
                    value={rowData.yom}
                    onChange={(e) => {
                        if (isRegistration(rowData)) {
                            return null;
                        }
                        updateVehicleItemValue(rowIndex, "yom", e.value)
                    }}
                    readOnlyInput
                />
            }
        },
        {
            field: 'usage', header: 'Usage', hide: !utils.isSME(), body: (rowData, { rowIndex }) => {
                return <Dropdown name="usage" value={rowData['usage']} options={usages} onChange={(e) => updateVehicleItemValue(rowIndex, 'usage', e.value)} optionLabel="name" />

            }
        },

        {
            field: 'actions', header: '', body: (rowData, { rowIndex }) => {
                return <Button onClick={() => deleteVehicleItem(rowIndex)} icon="pi pi-trash" className="p-button-rounded p-button-outlined table-delete-btn border-none" type="button" />
            }
        },
    ];

    return (
      <div className="item">
        <div className="header mb-3">
          <p className="text-xs text-bold fm-tawuniya">{i18n.t("STEPPER.VEHICLEDETAILS")}</p>
        </div>
        <Divider />
        <div>
          <DataTable
            value={formik.values.vehicles}
            editMode="cell"
            className="editable-cells-table my-3"
            responsiveLayout="scroll"
          >
            {columns.map(({ field, header, hide, body }) => {
              return hide ? null : (
                <Column
                  key={field}
                  field={field}
                  header={header}
                  body={body || null}
                />
              );
            })}
          </DataTable>
        </div>
        {canAddMore && (
          <Button
            onClick={addNewVehicle}
            label= {i18n.t("MotorEn.AddAnother")}
            icon="pi pi-plus"
            className="p-button-sm add-vehicle my-3"
            style={{background: businessColor}}
          />
        )}
      </div>
    );
};

export default MultipleVehicles;